import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function HostNameField({ hostName, error, disabled }) {
    const isDuplicateError = error === 'This device name already exists';

    useEffect(() => {
        validationService.validateHostName(hostName, 'hostName')
        return () => validationService.cleanValidation('hostName');
    }, [hostName])

    const [touched, setTouched] = useState(false);

    const onChange = (value) => modalDataService.changeHostName(value)

    return (
        <>
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="hostname">Hostname <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${(error && touched) && 'border-danger'}`}
                    id="hostname"
                    value={hostName}
                    placeholder="e.g., WinServer01"
                    disabled={disabled}
                    onFocus={() => setTouched(true)}
                    onChange={event => onChange(event.target.value)} />
                {isDuplicateError && (
                    <div className="text-danger mt-1">{error}</div>
                )}
            </div>
        </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("HostNameField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        hostName: addDeviceModal.hostName || '',
        error: validation.hostName
    }
}

export default connect(mapStateToProps)(HostNameField);
